import { createRoot } from "react-dom/client";
import { initSentry } from "./lib/sentry";
import { initPostHog } from "./lib/posthog";
import { startWebVitals } from "./lib/webVitals";
import "./i18n";
import App from "./App.tsx";
import "./index.css";

initSentry();
initPostHog();
startWebVitals();

createRoot(document.getElementById("root")!).render(<App />);
